<template>
  <dd-button
    v-if="$permissions.isAdminOrOwner"
    :size="size"
    :color="ColorAssistant.ProjectColor"
    new-icon
    @click="goToCreateProject()"
  ><i class="ddi ddi-project" />&nbsp;<span>New Project</span></dd-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import RouteAssistant from '@/helpers/route-assistant'
import AppSumoAssistant from '@/helpers/appsumo-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Only displays for admin/owners on tablet/desktop */
export default defineComponent({
  name: 'NewProjectButton',

  props: {
    size: {
      type: String,
      default: 'large',
    },
    workflowId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      RouteAssistant,
      ColorAssistant,
    }
  },
  methods: {
    async goToCreateProject() {
      if (
        await AppSumoAssistant.isUnderInternalProjectLimit(
          this.$router,
          this.$permissions,
        )
      ) {
        if (this.workflowId) {
          RouteAssistant.goToCreateProject(
            this.$router,
            this.$route.params.accountId,
            this.workflowId,
          )
        } else {
          RouteAssistant.goToCreateProject(
            this.$router,
            this.$route.params.accountId,
          )
        }
      }
    },
  },
})
</script>
